import { ToAbsoluteURL, SaveToFile, classPrintWorld } from './PrintWorld.js'

// eslint-disable-next-line new-cap
var printWorld = new classPrintWorld() //new一个打天下对象。不提供URL参数，意为本机的打天下打印服务器（"http://127.0.0.1:8888"）。

/**
 * 直接打印
 *
 * @param tplUrl         模板URL
 * @param data           打印数据
 * @param callBackUrl    回调函数（java后台方法）
 */
function btPrint_onclick(tplUrl, data, callBackUrl) {
  OnPrinters()//获取打印机列表。
  OnPrint(tplUrl, data, callBackUrl) //打印
}

/**
 * 预览报表
 *
 * @param tplUrl         模板URL
 * @param data           打印数据
 */
function btPreview_onclick(tplUrl, data) {
  OnPreview(tplUrl, data) //预览
}


// eslint-disable-next-line no-unused-vars
function OnLoad() {
  PrepareData()
  OnPrinters()//获取打印机列表。
}

var tmplArr = ['发票', '借款申请单', '境外汇款申请书', '采购订单', '送货单', '圆通二联单', '门票'] //本示例所用模板名称（数组）

function PrepareData() {
  var sel = document.getElementById('SelTmpl')
  sel.options.length = 0 //clear

  for (var i = 0; i < tmplArr.length; i++) {
    sel.options.add(new Option(tmplArr[i], tmplArr[i]))
  }
  sel.selectedIndex = 0
}


function OnPreview(tplUrl, jsonData) { //预览
  var json = {}
  json.action = 'preview' //预览
  json.template = ToAbsoluteURL(tplUrl) //位于web服务器上的模板文件URL，或者本地模板路径。
  json.data = jsonData //填充模板的预览数据(json)

  json = printWorld.Direct(json) //直接发送数据到打印服务器（同步调用方法）
  if (json == null) { //数据发送失败
    alert(printWorld.GetLastError())
  } else if (json.error !== undefined) { //打天下打印服务返回的错误信息
    alert(json.error)
  }
}

/**
 * 直接打印
 *
 * @param tplUrl         模板URL
 * @param data           打印数据
 * @param callBackUrl    回调函数（java后台方法）
 */
function OnPrint(tplUrl, jsonData, callBackUrl) { //打印输出
  var json = {}
  json.action = 'print' //打印
  json.template = ToAbsoluteURL(tplUrl) //位于web服务器上的模板文件URL。
  json.data = jsonData //填充模板的打印数据(json)

  json.callbackurl = callBackUrl// 回调服务端方法
  printWorld.PrintDialog(json)
}

/**
 * 异步调用打天下打印服务的回调函数：PrintWorldAsyncCallback。
 * web客户端可以通过异步方法（Act）、也可以通过同步方法（Direct）向打天下打印服务器发送JSON数据。同步方法不需要回调函数。
 */
// eslint-disable-next-line no-unused-vars
function PrintWorldAsyncCallback() {
  if (this.readyState !== 4) { // 4 = "loaded"
    return
  }
  if (this.status === 200) { // 200 = OK
    var json = eval('(' + this.responseText + ')')
    if (json.error !== undefined) { //返回错误信息
      alert(json.error)
    } else if (json.cmd === 'printers') { //打印机列表
      Printers2List(json)
    } else if (json.cmd === 'print') { //打印已提交，无需再做处理。
    } else if (json.cmd === 'print2file') { //打印到文件
      SaveToFile(json.val, 'noname', json.ext) //保存文件
    } else if (json.cmd === 'preview') { //跳转到预览页面
      window.open(printWorld.PrintURL() + '/' + json.val, '_blank') //另启窗口预览（浏览器会出现阻止弹窗提示）。因此建议：预览使用Direct同步调用。
    } else if (json.cmd === 'prnstatus') { //打印机状态
      //alert(json.printer.ready);
    } else if (json.cmd === 'whoareyou') {
      //alert("Ready!");
    }
  } else {
    if (this.statusText != null && this.statusText !== undefined && this.statusText !== '') {
      alert('Http error status:' + this.status.toString() + ' : ' + this.statusText)
    } else {
      alert('Http error status:' + this.status.toString())
    }
  }
}

function OnPrinters() { //获取打印机列表
  var json = '{"action":"printers"}' //获取打印机列表的JSON
  if (!printWorld.Act(json)) { //调用（异步发送JSON数据到）打天下FlexPrint。
    alert(printWorld.GetLastError()) //出错，显示错误信息。
  }
}

// eslint-disable-next-line no-unused-vars
function OnPrinterStatus(printerName) { //获取指定打印机的状态
  var json = {}
  json.action = 'prnstatus'
  json.printer = printerName
  if (!printWorld.Act(json)) { //异步调用（发送JSON数据到）打天下FlexPrint。
    alert(printWorld.GetLastError()) //出错，显示错误信息。
  }
}

// eslint-disable-next-line no-unused-vars
function OpenDesigner() { //通过浏览器打开模板设计器
  var path = 'E:\\MyApp\\FlexPrint\\Debug\\web\\template\\'
  var json = { 'action': 'designer' }
  json.from = path + document.getElementById('SelTmpl').value + '.fmx'
  //json.name = "发票";
  //json.from = "http://localhost:8084/PrintWorld/GetTemplate.jsp";
  //json.to = "http://localhost:8084/PrintWorld/SetTemplate.jsp";
  //json.name = "小票";
  //json.server = "http://10.88.12.64:8888";
  //json.id = "26";
  if (!printWorld.Act(json)) {
    alert(printWorld.GetLastError()) //出错，显示错误信息。
  }
}

// eslint-disable-next-line no-unused-vars
function OpenDesignerVer2() { //通过浏览器打开模板设计器
  var json = { 'action': 'designer' }
  json.from = 'http://localhost:8084/PrintWorld/GetTemplate.jsp'
  json.to = 'http://localhost:8084/PrintWorld/SetTemplate.jsp'
  json.name = '电子面单'
  //json.server = "http://localhost:8888";
  //json.id = "181";

  if (!printWorld.Act(json)) {
    alert(printWorld.GetLastError()) //出错，显示错误信息。
  }
}

function Printers2List(json) { //将（打天下打印服务能访问到的）打印机填充到下拉列表组合框
  var sel = document.getElementById('SelPrinter')
  sel.options.length = 0 //清空列表
  //填充列表
  var prns = json.val
  sel.options.add(new Option('', ''))
  for (var i = 0; i < prns.length; i++) {
    sel.options.add(new Option(prns[i].name, prns[i].name))
    //sel.options.add(new Option(prns[i].name_friendly, prns[i].name_friendly));
  }
}

/**
 * 获取指定模板服务器、指定路径下的模板。
 * 调用示例：TemplateList("http://12.34.3.45:8888","人事部")
 * @server：打天下模板服务器：IP:端口
 * @path：路径（目录），支持多级目录，形式如abc/xyz/..，其中abc为根目录下的目录，xyz为abc下的目录，依次类推。
 * 如果成功返回模板JSON数组，形式如：
 *   [
 *        {
 *            "id":"12","name":"档案"
 *        },
 *        {
 *            "id":"18","name":"凭证"
 *        },
 *        ...
 *    ]
 */
// eslint-disable-next-line no-unused-vars
function TemplateList(server, path) {
  var json = { 'action': 'templatelist' }
  json.path = path
  // eslint-disable-next-line new-cap
  var pw = new classPrintWorld(server)
  // eslint-disable-next-line no-undef
  json = pw.Direct(json) //直接发送数据到打印服务器
  if (json == null) {
    // eslint-disable-next-line no-undef
    alert(pw.GetLastError())
  } else if (json.error !== undefined) {
    alert(json.error)
  } else {
    return json.templatelist
  }
}

// eslint-disable-next-line no-unused-vars
function TemplChanged(index) { //从下拉列表组合框中选择了一个模板
  // eslint-disable-next-line no-undef
  document.getElementById('DATA').value = dataArr[index]
}

// eslint-disable-next-line no-unused-vars

export { btPrint_onclick, btPreview_onclick }
